import React, { useEffect, useState } from 'react'
import {
  withStyles,
  Typography,
  Button,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio
} from '@material-ui/core'
import { Link, EmailField, FormField } from '../index'
import { isEmpty } from 'lodash'
import { t as i18n } from 'ttag'
import { useForm } from 'react-hook-form/dist/react-hook-form.ie11'

const styles = theme => ({
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(4)
  },
  tenantField: {
    marginTop: 16
  },
  buttonsContainer: {
    marginTop: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  button: {
    float: 'right',
    margin: 0
  },
  link: {
    float: 'left'
  },
  linkContainer: {
    display: 'inline-block'
  },
  formControl: {
    display: 'none'
  }
})

const Form = props => {
  const { classes, backToLoginLink, callback, utid } = props
  const { register, handleSubmit, errors } = useForm({
    reValidateMode: 'onSubmit'
  })

  const [values, setValues] = useState({
    tenant: '',
    email: '',
    username: ''
  })

  useEffect(() => {
    setValues({ ...values, tenant: utid, username: `${values.email}@${utid}` })
  }, [])

  const handleChange = name => event => {
    setValues({
      ...values,
      [name]: event.target.value,
      ...(name === 'tenant'
        ? { username: `${values.email}@${event.target.value}` }
        : {}),
      ...(name === 'email'
        ? { username: `${event.target.value}@${values.tenant}` }
        : {})
    })
  }

  const [value, setValue] = React.useState('EMAIL')

  const handleChangeRadio = event => {
    setValue(event.target.value)
  }

  const onSubmit = data => {
    if (isEmpty(errors)) {
      document.getElementById('ForgotPassword-container').submit()
    }
  }

  const handleError = field => {
    return errors.hasOwnProperty(field)
  }

  return (
    <form
      id='ForgotPassword-container'
      className={classes.form}
      onSubmit={handleSubmit(onSubmit)}
      noValidate={true}
      method='post'
      action='verify.do'
    >
      <Typography
        variant='body2'
        className={classes.link}
        color='textSecondary'
      >
        {i18n`Please provide your username to recover your password. Instructions will be sent to your registered email.`}
      </Typography>

      <FormField
        id={`TenantField-ForgotPassword-tenant`}
        className={classes.tenantField}
        data-cid='TenantField-root'
        label={i18n`Domain name`}
        name='tenant'
        onChange={handleChange('tenant')}
        value={values.tenant}
        errors={errors}
        inputRef={register({ required: i18n`Enter your domain name` })}
        required
      />

      <FormField
        id={`EmailField-Login-tenant`}
        data-cid='EmailField-root'
        label={i18n`Email`}
        name='email'
        onChange={handleChange('email')}
        value={values.email}
        errors={errors}
        inputRef={register({ required: i18n`Enter your email` })}
        required
      />

      <EmailField
        id={'ForgotPassword-email'}
        onChange={handleChange('username')}
        value={values.username}
        errors={errors}
        inputRef={register({
          required: i18n`Enter your email`,
          pattern: {
            value: /([\w\.\-_]+)?\w+@[\w-_]+(\.\w+){1,}?\w+(@[\w-_]+(\.\w+){1,})*/,
            message: i18n`Please enter your email address in format: yourname@example.com and it cannot exceed 320 characters.`
          }
        })}
      />

      <FormControl component='fieldset' className={classes.formControl}>
        <RadioGroup
          aria-label='recover'
          name='recoveryOption'
          value={value}
          onChange={handleChangeRadio}
        >
          <FormControlLabel
            value='EMAIL'
            control={<Radio />}
            label='Recover with Mail'
          />
          <FormControlLabel
            value='SECURITY_QUESTIONS'
            control={<Radio />}
            label='Recover with Security Questions'
          />
        </RadioGroup>
      </FormControl>

      <input type='hidden' name='callback' value={callback} />

      <div className={classes.buttonsContainer}>
        <Link
          className={classes.link}
          to={backToLoginLink}
          data-qid={'ForgotPassword-link'}
        >{i18n`Back to Login`}</Link>

        <Button
          type='submit'
          variant='contained'
          color='primary'
          className={classes.button}
          data-qid={'ForgotPassword-button-submit'}
        >
          {i18n`Send`}
        </Button>
      </div>
    </form>
  )
}

export default withStyles(styles)(Form)
